import React, { useEffect, useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  BsCheckCircleFill,
  BsTruck,
  BsBagCheckFill,
  BsHouseDoor,
  BsArrowLeft,
  BsPerson
} from "react-icons/bs";
import { UserContext } from "../../context/userContext";
import "./orderSuccess.css";

export default function OrderSuccess() {
  const { updateUserData } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const paymentRequestId = searchParams.get("payment_request_id") || searchParams.get("payment_id") || "";
  const paymentId = searchParams.get("payment_id") || searchParams.get("payment_status") || "";

  useEffect(() => {
    window.scrollTo(0, 0);
    if (updateUserData) {
      updateUserData({ cart: [] });
    }
    // Clear any temporary cart items from local storage if stored
    try {
      window.localStorage.removeItem("cart");
    } catch (_) {}
  }, []);

  const handleGoBack = () => {
    navigate("/", { replace: true });
  };

  const handleContinueShopping = () => {
    navigate("/", { replace: true });
  };

  return (
    <div className="order-success-page">
      <div className="order-success-card">
        {/* Back Button */}
        <div className="text-start mb-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary rounded-pill px-3 py-1 d-inline-flex align-items-center gap-1 shadow-xs border fw-semibold"
            onClick={handleGoBack}
            title="Go back to previous page"
          >
            <BsArrowLeft className="fs-6" /> Back
          </button>
        </div>

        {/* Success Icon */}
        <div className="success-icon-wrapper">
          <BsCheckCircleFill />
        </div>

        {/* Badge */}
        <span className="badge bg-success bg-opacity-10 text-success fw-bold px-3 py-2 rounded-pill mb-3 text-uppercase fs-6">
          <BsBagCheckFill className="me-1 mb-1" /> Order Confirmed
        </span>

        {/* Title & Message */}
        <h2 className="fw-bold text-dark mb-2">Thank You For Your Order!</h2>
        <p className="text-secondary mb-3 fs-6">
          Your payment was successfully completed and your order has been placed. We are preparing your items for delivery.
        </p>

        {/* Order Details Card */}
        <div className="order-info-box">
          <div className="row g-2 text-start">
            <div className="col-12 col-sm-6 mb-2">
              <small className="text-muted text-uppercase d-block fw-semibold" style={{ fontSize: "0.75rem" }}>
                Payment Reference ID
              </small>
              <span className="fw-bold text-dark font-monospace" style={{ wordBreak: "break-all" }}>
                {paymentRequestId || paymentId || "COMPLETED"}
              </span>
            </div>
            <div className="col-12 col-sm-6 mb-2">
              <small className="text-muted text-uppercase d-block fw-semibold" style={{ fontSize: "0.75rem" }}>
                Payment Status
              </small>
              <span className="badge bg-success text-white px-2 py-1 rounded-pill">
                Paid & Completed
              </span>
            </div>
            <div className="col-12 border-top pt-2 mt-2">
              <small className="text-muted text-uppercase d-block fw-semibold mb-1" style={{ fontSize: "0.75rem" }}>
                Fulfillment & Shipping
              </small>
              <p className="small text-secondary mb-0">
                You will receive updates on your shipment status. You can also view all your order tracking details anytime in your <strong>Tracker</strong> page.
              </p>
            </div>
          </div>
        </div>

        {/* Continue Shopping Button (Primary Button directly below message/card) */}
        <button
          type="button"
          onClick={handleContinueShopping}
          className="btn btn-success-gradient w-100 py-3 fw-bold text-uppercase fs-6 d-inline-flex align-items-center justify-content-center gap-2 shadow-sm my-2"
        >
          <BsHouseDoor className="fs-5" /> Continue Shopping
        </button>

        {/* Additional Navigation Links */}
        <div className="d-flex flex-column flex-sm-row justify-content-center gap-2 mt-3">
          <Link
            to="/tracker"
            className="btn btn-outline-dark-custom d-inline-flex align-items-center justify-content-center text-decoration-none py-2 px-3 fs-6"
          >
            <BsTruck className="me-2 fs-5" /> View Order Tracker
          </Link>
          <Link
            to="/profile"
            className="btn btn-outline-dark-custom d-inline-flex align-items-center justify-content-center text-decoration-none py-2 px-3 fs-6"
          >
            <BsPerson className="me-2 fs-5" /> My Profile & Orders
          </Link>
        </div>
      </div>
    </div>
  );
}
